import { useEffect, useRef } from 'react';
import { bridge } from 'shared/src/utils';
import { GOODS_RANKING_SCREEN } from './getCommonFilterAnalytics';

export const useLogViewGoodsRanking = () => {
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (hasLoggedRef.current) return;
    hasLoggedRef.current = true;

    bridge.logAnalyticsEvent({
      name: 'VIEW_GOODS_RANKING',
      analytics: {
        SCREEN: GOODS_RANKING_SCREEN,
      },
    });
  }, []);
};
